import { style } from '@vanilla-extract/css';
import { config } from 'folds';

export const RoomTombstone = style({
  padding: config.space.S200,
  paddingLeft: config.space.S400,
});
